import {ACTION_TYPES, KEY_CODES} from "../consts";
import {ActionHandler} from "../../infrastructure/handlers/action-handler";
import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";

export class NotificationSecondNoticeDisplayHandler extends ActionHandler {
  analyticsService: AnalyticsService;
  type = ACTION_TYPES.notificationSecondNoticeDisplay;

  static injectables = [...ActionHandler.injectables];

  onLoaded() {
    super.onLoaded();

    window.addEventListener('keydown', (event: KeyboardEvent) => {
      if(event.keyCode === KEY_CODES.escape) {
        this.action({isVisible: false})
      }
    });
  }

  action(params) {
    this.appStore.state.appNotificationDisplayModel.shouldRenderSecondNoticeMessage = params.isVisible;
  }
}
